import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';

import { Footer, H3, LayoutSingleColumn, Page } from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import Icon from './images/icon.png';
import ClientsImage from './images/clientsImage.png';
import FreelancersImage from './images/freelancersImage.png';
import tipIcon from './images/tip_icon.png';

import css from './PricingPage.module.css';

export const PricingPageComponent = props => {
  const config = useConfiguration();
  const { intl } = props;

  const title = intl.formatMessage({ id: 'PricingPage.title' });

  return (
    <Page className={css.root} title={title}>
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer isDark={true} currentPage="PricingPage" />
            {/* <UserNav currentPage="PricingPage" /> */}
          </>
        }
        footer={<Footer />}
        mainColumnClassName={css.rootBackground}
      >
        <div>
          <div className={css.headingContainer}>
            <img className={css.headingIcon} src={Icon} />
            <H3 className={css.heading}>{title}</H3>
          </div>

          <div className={css.horizontalWrapper}>
            <div className={css.tipContainer}>
              {/* <div className={css.tipHeader}>
                <img className={css.tipIcon} src={tipIcon} />
                <div>
                  <p className={css.proTip}>
                    <FormattedMessage id={'TipsPanel.proTip'} />
                  </p>
                  <h1 className={css.tipTitle}>
                    <FormattedMessage id="PricingPage.pricingPlans" />
                  </h1>
                </div>
              </div> */}
              <p className={css.tipTitle}>
                <FormattedMessage id="PricingPage.pricingPlans" />
              </p>

              <div className={css.line} />

              <p>
                <span className={css.tip}>
                  <FormattedMessage id="PricingPage.pricingPlans.info1" />
                </span>
                <span className={css.tipHighlight}>
                  <FormattedMessage id="PricingPage.pricingPlans.info2" />
                </span>
              </p>
              <p>
                <span className={css.tip}>
                  <FormattedMessage id="PricingPage.pricingPlans.info3" />
                </span>
                <span className={css.tipHighlight}>
                  <FormattedMessage id="PricingPage.pricingPlans.info4" />
                </span>
                <span className={css.tip}>
                  <FormattedMessage id="PricingPage.pricingPlans.info5" />
                </span>
                <span className={css.tipHighlight}>
                  <FormattedMessage id="PricingPage.pricingPlans.info6" />
                </span>
                <span className={css.tip}>
                  <FormattedMessage id="PricingPage.pricingPlans.info7" />
                </span>
              </p>
            </div>

            <div className={css.pricingCardsWrapper}>
              <div className="blurContainer">
                <div className={css.pricingContainer}>
                  <img className={css.image} src={FreelancersImage} />

                  <p className={css.pricingTitle}>
                    <FormattedMessage id="PricingPage.freelancers" />
                  </p>

                  <div className={css.line} />

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.registration" />
                  </p>

                  <p className={css.value}>
                    <FormattedMessage id="PricingPage.registrationFree" />
                  </p>

                  <div className={css.line} />

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.bidForProjects" />
                  </p>

                  <p className={css.value}>
                    <FormattedMessage id="PricingPage.bidForProjectsFree" />
                  </p>

                  <div className={css.line} />

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.comission" />
                  </p>

                  <p className={css.value}>
                    <FormattedMessage id="PricingPage.comissionValue" />
                  </p>

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.onRevenue" />
                  </p>
                </div>
              </div>

              <div className="blurContainer">
                <div className={css.pricingContainer}>
                  <img className={css.image} src={ClientsImage} />

                  <p className={css.pricingTitle}>
                    <FormattedMessage id="PricingPage.clients" />
                  </p>

                  <div className={css.line} />

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.registration" />
                  </p>

                  <p className={css.value}>
                    <FormattedMessage id="PricingPage.registrationFree" />
                  </p>

                  <div className={css.line} />

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.postProjects" />
                  </p>

                  <p className={css.value}>
                    <FormattedMessage id="PricingPage.postProjectsFree" />
                  </p>

                  <div className={css.line} />

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.serviceFee" />
                  </p>

                  <p className={css.value}>
                    <FormattedMessage id="PricingPage.serviceFeeValue" />
                  </p>

                  <p className={css.info}>
                    <FormattedMessage id="PricingPage.onInvoiced" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

PricingPageComponent.defaultProps = {
  config: null,
};

PricingPageComponent.propTypes = {
  // from useConfiguration()
  config: object,

  // from injectIntl
  intl: intlShape.isRequired,
};

const PricingPage = compose(
  connect(),
  injectIntl
)(PricingPageComponent);

export default PricingPage;
